module.exports = __webpack_public_path__ + "img/pixing_xc17.00893d10.jpg";